import "./PrivacyPolicyPage.css";
import { Footer } from "../components/ConstantComponent";

const PrivacyPolicyPage = () => {
  return (
    <div className="page">

      <div className="privacy-container">

        <div className="privacy-header">

          <p className="privacy-tag">
            LEGAL
          </p>

          <h1 className="privacy-title">
            Privacy Policy
          </h1>

          <p className="privacy-subtitle">
            We respect your privacy and are committed to protecting your information while using IPR Technologies' services.
          </p>

        </div>

        <div className="privacy-card">

          <h2>Our Commitment</h2>

          <p>
            At IPR Technologies, protecting your privacy is one of our highest priorities.
            We do not collect personal information unless you voluntarily provide it through our official communication channels.
          </p>

          <h2>Information Collection</h2>

          <p>
            We do not collect sensitive personal information such as your name,
            email address, phone number or browsing history during normal use of
            this website.
          </p>

          <h2>Technical Information</h2>

          <p>
            Certain technical information such as browser type, cookies and device
            information may be collected automatically only to improve website
            performance and security.
          </p>

          <h2>Security</h2>

          <p>
            We use reasonable security practices to safeguard all information and
            continuously improve our systems against unauthorized access.
          </p>

          <h2>Policy Updates</h2>

          <p>
            This Privacy Policy may be updated whenever required. Any changes will
            be published on this page.
          </p>

          <h2>Contact</h2>

          <p>
            Email:
            <span className="privacy-highlight">
              {" "}info@iprtechnologies.com
            </span>

            <br />

            Phone:
            <span className="privacy-highlight">
              {" "}+91 9902668672
            </span>
          </p>

        </div>

      </div>

      <Footer />

    </div>
  );
};

export default PrivacyPolicyPage;